import styled from 'styled-components';

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const RadioInputWrapper = styled.div`
  display: flex;
  gap: 24px;
`;

const RadioInputLabel = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

export { Form, FormItem, RadioInputLabel, RadioInputWrapper };
